import { ref } from 'vue'

export function createCustomersState() {
    function getInitialFilters() {
        return {
            name: '',
            customer: '',
            nip: '',
            isHidden: 'false'
        }
    }

    return {
        customer: ref(null),
        customers: ref([]),
        customersLoading: ref(false),
        filters: ref(getInitialFilters()),
        customersTypes: ref([]),
        customerContacts: ref([]),
        customerAddresses: ref([]),
        addressTypes: ref([]),
        countries: ref([]),
        productionFileCustomerConfiguration: ref([]),
        customerAddressesLoading: ref(false),
        customerContactsLoading: ref(false)
    }
}
